export const MATCHING_PROMPT_EXAMPLES: string[] = [
  'Find me a Spanish-speaking trauma therapist with an opening this week',
  'Show providers who do DBT and accept Cigna',
  'Filter to telehealth-only providers available on Thursdays',
  "Who's the best match for an adolescent patient needing CBT?",
  'Clear the provider filters',
  'Show all providers',
  'Which providers speak Mandarin?',
  'Find someone available for an urgent appointment tomorrow morning',
];

export const MATCHING_TOOL_DESCRIPTION = `
Provider matching (matchingCommand) — only set when providerMatching is enabled:
  Use matchingCommand when the user asks to filter, rank, or clear matched providers.
  Intents:
    FILTER  — filter the resource list by specific criteria
    RANK    — re-rank providers by new criteria without hiding others
    QUERY   — answer a question about who matches (set reply to the answer, no matchingCommand needed)
    CLEAR   — remove all matching filters and show all providers

  criteria fields (all optional, include only what the user specified):
    specialty:          string[]  — e.g. ["trauma", "adolescent"]
    modality:           string[]  — e.g. ["CBT", "DBT", "EMDR"]
    language:           string[]  — BCP 47 codes: ["en", "es", "zh-TW"]
    genderPreference:   "male" | "female" | "nonbinary" | "no_preference"
    ageGroupPreference: "child" | "adolescent" | "adult" | "older_adult"
    insuranceId:        string    — insurance plan identifier
    locationPreference: "in_person" | "telehealth" | "either"

  raw: always include the verbatim user message for the host audit log.

  Examples:
    "Find a Spanish-speaking CBT provider"
      → { intent:"FILTER", criteria:{ language:["es"], modality:["CBT"] }, raw:"<verbatim>" }
    "Show telehealth providers available Thursday afternoons"
      → { intent:"FILTER", criteria:{ locationPreference:"telehealth" }, raw:"<verbatim>" }
    "Who's best for an adolescent needing DBT?"
      → { intent:"RANK", criteria:{ ageGroupPreference:"adolescent", modality:["DBT"] }, raw:"<verbatim>" }
    "Clear provider filters" / "Show all providers"
      → { intent:"CLEAR", criteria:{}, raw:"<verbatim>" }
`;
